<template>
    <form action="#" v-on:submit.prevent>
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Controle de Acesso | Login</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Email">
                    <b-input
                        ref='email'
                        v-model="form.email"
                        type="email"
                        :value="form.email"
                        placeholder="Digite seu e-mail"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Senha">
                    <b-input
                        ref='senha'
                        v-model="form.senha"
                        type="password"
                        :value="form.senha"
                        password-reveal
                        placeholder="Digite sua senha"
                        required>
                    </b-input>
                </b-field>

                <b-checkbox v-model="form.lembrarLogin">Lembrar-me</b-checkbox>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Fechar</button>
                <button class="button is-primary" @click="onLogin()">Logar-se</button>
            </footer>
        </div>
    </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ModalFormLogin',
  // props: ['email', 'senha'],
  data: () => ({
    form: {
      // email: 'admin@email.com',
      // senha: 'admin'
      email: '' || localStorage.getItem('api_login'),
      senha: '',
      lembrarLogin: false || localStorage.getItem('api_lembrar')
    }
  }),
  methods: {
    ...mapActions('login', [
      'login',
      'logout'
    ]),
    onLogin () {
      this.login(this.form).then((res) => {
        this.$router.push('/dashboard')
        this.$parent.close()
      }
      ).catch(
        (error) => {
          this.loading = false
          // this.$message.error('Erro ao tentar fazer login!')
          this.$vs.notify({ title: 'Atenção!!!', text: error.msg, color: 'danger', icon: 'error', position: 'top-center' })
          window.console.error(error)
          // document.getElementsByTagName('input')[0].focus()
        }
      )
    }
  },
  computed: {
    ...mapState('login', [
      'logged',
      'usuario'
    ])
  },
  mounted: function () {
    if (localStorage.getItem('api_login') !== null) {
      this.$refs.senha.focus()
    } else {
      this.$refs.email.focus()
    }
  }
}
</script>
